import(/* webpackMode: "eager" */ "/builds/Instacover/instaclaim-instacar/apps/customerPortal/src/app/[locale]/auth/reset-password/page.tsx");
